import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { primeQueryCache } from "../../../utils/primeQueryCache";
import { SponsorDto } from "../../../models/sponsor/dto/sponsor.dto";
import { GET_SPONSOR_QUERY_KEY } from "./useGetSponsor";

export const GET_SPONSORS_QUERY_KEY = (organizationId: string, includeInactive?: boolean) => ['sponsors', 'list', organizationId, includeInactive];
export const useListSponsors = (organizationId: string, includeInactive = false) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: GET_SPONSORS_QUERY_KEY(organizationId, includeInactive),
        queryFn: () => client.fetchApi<SponsorDto[], {}>({
            endpoint: `sponsors/admin/list/all?organizationId=${organizationId}&includeInactive=${includeInactive}`,
            method: 'GET'
        }),
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
        onSuccess: (data: SponsorDto[]) => {
            // O(items), not O(items × cache) — see primeQueryCache for the org-switch freeze this loop was part of.
            primeQueryCache(queryClient, (item) => GET_SPONSOR_QUERY_KEY(item.id), data);
        },
    });
};
